// Setup router
var router = new VueRouter({
  mode: 'history',
  routes: []
});

// Main view app
var app = new Vue({
  router: router,
  el: '#app',

  // Filters
  filters: {
    // Format date
    formatDate: function (value) {
      var f = value.split(" ")[0];
      var t = f.split("/");
      return t[1] + '/' + t[2] + '/' + t[0];
    },

    // Highlight searched term
    highlight: function (value, searchTerm) {
      let index = value.toLowerCase().indexOf(searchTerm.toLowerCase());

      if (index < 0) {
        return value;
      }

      return value.substring(0, index) + "<span class='highlight'>" + value.substring(index, index + searchTerm.length) + "</span>" + value.substring(index + searchTerm.length);
    }
  },

  // Data useed in this component
  data: {
    _pc: '',
    searchTerm: '',
    fullSearch: false,

    page: 'landing',
    lastPage: '',

    files: [],

    loaded: false,
    isOpen: false,

    showBreadcrumbFlag: true,

    authError: false,

    contactSubmitError: false,

    contactErrorMessage: "There was an error submitting your contact request.",

    showOverlay: false,

    showToc: false,

    printMode: false,

    contactSuccess: false,

    showArticleIFrame: false,

    article: {},

    searchResults: [],

    contactSearchResults: [],
    contactSearchCollapse: false,

    fullSearchResults: [],
    haveFullSearchResults: false,

    parentWidth: 1000,

    recommended: [],
    manualRecPage: false,

    activeLevel: {
      name: '',
      categories: [],
      articles: []
    },

    loadedToc: false,
    toc: {
      categories: [],
      articles: []
    },

    breadcrumb: [
      { title: "Home", url_hash: "", toc: [] }
    ],

    tempBreadcrumb: [
      { title: "Home", url_hash: "", toc: [] }
    ],

    config: {
      helpdomains: [],
      content_text: {
        en: {
          search_title: '',
          search_placeholder: ''
        }
      }
    },

    contact: {
      name: "",
      email: "",
      details: "",
      subject: ""
    },

    honeypotHTML: "",

    token: null,
  },

  // Method used in this component
  methods: {
    //Helper function for navigation to landing page. Used to remember previously opened articles and categories. 
    knowledgeTabNaviate: function () {
      if (this.article.url) {
        this.showArticleIFrame = false;
        this.page = 'article';
      }
      else {
        this.page = 'landing';
      }
    },

    // open widget
    open: function () {
      var that = this;

      // only perform if widget isn't already open
      if(that.isOpen !== true)
      {
        that.isOpen = true;

        // load the toc
        if(! that.loadedToc)
          that.getToc();

        // Load recommended
        if (that.manualRecPage || !this.config.suggested_url || this.config.suggested_url != 'none') {
          this.getRecommended();
        }
      }
    },

    // Close widget
    close: function () {
      //reset submitted contact form
      this.contactSuccess = false;

      // Send message to parent TODO: Change * to real domain. Or look into if there are security issues doing this.
      parent.postMessage({ action: 'close' }, '*');
    },

    // update widget open state
    closed: function() {
      this.isOpen = false;
    },

    // Close Search
    closeSearch: function () {
      this.searchTerm = '';
      this.search({ keyCode: 0 });
      return false;
    },

    // Just catch form submits
    searchSubmit: function () {
      return;
    },

    // Call this when contact search is blured.
    contactBodyFocus: function () {
      // If there are search results, collapse the list and show expand message 
      if (this.contactSearchResults.length) {
        this.contactSearchCollapse = true;
      }
    },

    // Contact search
    searchContactSubmit: function (e) {
      var that = this;

      // Assign to search for highlighting to work.
      this.searchTerm = this.contact.subject;

      // Show the results list
      this.contactSearchCollapse = false;

      // Build URL
      let url = '/widget/search?__pc=' + this.$route.query.__pc + '&phrase=' + this.contact.subject + '&trackRes=false';

      // AJAX call to get data			
      axios.get(url)
        .then(function (response) {
          that.contactSearchResults = response.data.articles;
        })
        .catch(function (e) {
          console.log(e);
        });
    },

    // Search for articles 
    search: function (e) {
      var that = this;
      let full = false;

      // Ignore enter if search term is empty
      if (((e.keyCode == 13) || (e.keyCode == 8)) && (this.searchTerm.length == 0)) {
        if (this.lastPage) {
          this.page = this.lastPage;
          this.lastPage = '';
          this.searchResults = [];
          this.fullSearchResults = [];
          this.glossaryTerm = false;
        }
        return;
      }

      // Focus form
      setTimeout(function () { document.getElementById("search").focus(); }, 100);

      // Go back to the search page.
      if (this.searchTerm.length > 0) {
        if (this.lastPage == '') {
          this.lastPage = this.page;
        }
        this.page = 'search';
        this.glossaryTerm = false;
      } else {
        this.page = this.lastPage;
        this.lastPage = '';
        this.searchResults = [];
        this.glossaryTerm = false;
        return;
      }

      // Is this a full search
      if (e.keyCode == 13) {
        full = true;
        this.fullSearch = true;
        this.searchResults = [];
        this.fullSearchResults = [];
        this.glossaryTerm = false;
      } else {
        this.glossaryTerm = false;
        this.fullSearch = false;
      }

      // Build URL
      let url = '/widget/search?__pc=' + this.$route.query.__pc + '&phrase=' + this.searchTerm;

      if (!full) {
        url = url + '&trackRes=false';
      }

      // add current location
      var curPage = this.$route.query.__loc;
      url = url + '&__loc=' + curPage;

      // AJAX call to get data			
      axios.get(url)
        .then(function (response) {
          // Check if we get an auth error back
          if (response.data.error && response.data.error == 'Unauthorized') {
            that.authErrorResponse();
          } else {
            // If full we give a small delay for the non-fulls to complete. A little hacky
            if (that.fullSearch) {
              if (response.data.articles.length > 0) {
                that.haveFullSearchResults = true;
              } else {
                that.haveFullSearchResults = false;
              }

              if (full) {
                that.fullSearchResults = response.data.articles;
              }
            } else {
              that.searchResults = response.data.articles;
            }
            that.glossaryTerm = response.data.glossaryTerm || false;
          }
        })
        .catch(function (e) {
          console.log(e);
        });
    },

    // Receive config data from load-current
    updateConfig: function(data) {
      var that = this;

      that.config = JSON.parse(data);
      setTimeout(function () { that.doPostConfig(); }, 100);
    },

    // Get the configs based on how the user set up this widget in the KO admin panel.
    /* @todo I've deprecated this by passing the config in from load-config. Delete if this works out */
    getConfig: function () {
      var that = this;

      // AJAX call to get config
      axios.get('/widget/config?__pc=' + this.$route.query.__pc)
        .then(function (response) {
          that.config = response.data;
          setTimeout(function () { that.doPostConfig(); }, 100);
        })
        .catch(function (e) {
          console.log(e);
        });
    },

    // Run this function after we got our configs from the BE server.
    doPostConfig: function () {
      var h = document.getElementById('footer');

      if (h) {
        var b = 36 + h.offsetHeight;

        var style = document.createElement('style');
        style.innerHTML = '.article .scroll__cont { bottom: ' + b + 'px; }';
        document.head.appendChild(style);
      }

      // Do we have recaptcha?
      if (this.config.captcha_enabled && this.config.captcha_key && this.config.captcha_key.length) {
        var script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=' + this.config.captcha_key;
        document.head.appendChild(script);
      }
    },

    // Authenticate the widget with the passed in token
    authenticate: function (tokenObj) {
      var that = this;

      let tokenQuery = '&type=' + tokenObj.type + '&token=' + tokenObj.token;
      // AJAX call to authenticate using token info          
      axios.get('/widget/authenticate?__pc=' + this.$route.query.__pc + tokenQuery)
        .then(function (response) {
          // Authentication succeeded
          if (response.data.status == 'success') {
            that.updateContact(response.data.reader);
            // Refresh HTML
            that.token = response.data.token;
            if (that.token) {
              axios.defaults.headers.common = {
                "st": that.token,
              };
            }
            that.refreshViews();
            // Get rid of loading overlay
            that.showOverlay = false;
          }

          // Tell the parent what happened during the auth try
          parent.postMessage({ action: 'authResp', data: response.data }, '*');

          var d = document.getElementById('article-iframe');

          if (d && that.token) {
            d.contentWindow.postMessage({ token: that.token }, '*');
          }


        })
        .catch(function (e) {
          console.log(e);
        });
    },

    // Error response from server due to invalid or expired authentication
    authErrorResponse: function () {
      if (!this.authError) {
        // Display the loading overlay
        this.showOverlay = true;

        // Pass the info to the parent to notify
        parent.postMessage({ action: 'authError' }, '*');
      }
    },

    // Get all toc for the page we are on.
    getToc: function () {
      var that = this;
      that.loadedToc = true;
      // show spinner
      that.showOverlay = true;

      // AJAX call to get data			
      axios.get('/widget/toc?__pc=' + this.$route.query.__pc)
        .then(function (response) {
          // Check if we get an auth error back
          if (response.data.error && response.data.error == 'Unauthorized')
            that.authErrorResponse();
          else
            that.showOverlay = false; // hide spinner

          // Store master TOC
          that.toc = response.data;

          // Set active categories.
          that.activeLevel = that.toc;

          // Update the TOC
          that.breadcrumb[0].toc = that.toc;
        })
        .catch(function (e) {
          console.log(e);
        });
    },

    // Find within the TOC. Loop through until we find an 
    findToc: function (id, toc) {
      // Loop though articles
      for (let i = 0; i < toc.articles.length; i++) {
        let row = toc.articles[i];

        if (row.id == id) {
          return toc;
        }
      }

      // If not found in articles loop though categories
      for (let i = 0; i < toc.categories.length; i++) {
        let row = toc.categories[i];

        if (row.id == id) {
          return toc.categories[i];
        } else {
          let r = this.findToc(id, toc.categories[i]);

          if (r) {
            return r;
          }
        }
      }

      // Not found.
      return null;
    },

    // Get recommended articles
    getRecommended: function (page) {
      var that = this;
      
      // page manually passed in by end user
      if(page)
        that.manualRecPage = page;
      var curPage = that.manualRecPage ? that.manualRecPage : this.$route.query.__loc;
      
      // only make the ajax call if the widget is actually open
      if(that.isOpen)
      {
        // show spinner
        that.showOverlay = true;

        // AJAX call to get config
        axios.get('/widget/recommended?__pc=' + this.$route.query.__pc + '&__loc=' + curPage)
          .then(function (response) {
            // Check if we get an auth error back
            if (response.data.error && response.data.error == 'Unauthorized')
              that.authErrorResponse();
            else
              that.showOverlay = false; // hide spinner

            that.recommended = response.data;

            // only change the tab to recommended if they aren't looking at an article
            if(that.page != 'article')
            {
              // Default page is recommended if there are results for current url
              if (that.recommended.length > 0) {
                that.page = 'recommended';
              }

              // If they configued this, and only have one recommended go right to the article
              if (that.config.widget_open_recommended && (that.recommended.length == 1)) {
                if (that.recommended[0].type == 'Category' && that.recommended[0].subtype != 'content' && that.recommended[0].subtype != 'topic' && that.recommended[0].subtype != 'redirect')
                  that.viewRecommendedCategory(that.recommended[0]);
                else
                  that.viewRecommendedArticle(that.recommended[0]);
              }
            }
          })
          .catch(function (e) {
            console.log(e);
          });
      }
    },

    // Set breadcrumb from an ajax call to the BE. 
    setBreadcrumb: function (id, isCategory) {
      var that = this;

      // AJAX call to get crumb			
      axios.get('/widget/breadcrumb?__pc=' + this.$route.query.__pc + '&id=' + id)
        .then(function (response) {
          that.breadcrumb = [{ title: "Home", url_hash: "", toc: that.toc }];

          for (let i = 0; i < response.data.length; i++) {
            let row = response.data[i];
            let toc = that.findToc(row.id, that.toc);
            that.breadcrumb.push({ title: row.name, url_hash: row.link, toc: toc, hide_from_toc: row.hide_from_toc, hide_from_page: row.hide_from_page });

            if (isCategory) {
              that.breadcrumb.push({ title: "", url_hash: "", toc: [] });
            }
          }
        })
        .catch(function (e) {
          console.log(e);
        });
    },

    // Get last breadcrumb
    getLastBreadcrumb: function () {
      // We are on the home page.
      if (this.breadcrumb.length <= 1) {
        return null;
      }

      var rt = this.breadcrumb[this.breadcrumb.length - 2];

      if (rt.title == "") {
        rt.title = "Home";
      }

      return rt;
    },

    // Change breadcrumb click
    breadcrumbClick: function (tocLevel) {
      let nb = [];
      this.page = 'landing';
      this.article = {};

      for (let i = 0; i < this.breadcrumb.length; i++) {
        nb.push(this.breadcrumb[i]);

        if (this.breadcrumb[i].toc.id == tocLevel.id) {
          this.breadcrumb = nb;
          this.activeLevel = this.breadcrumb[i].toc;
          return;
        }
      }
    },

    // In some cases we might want to hide a breadcrumb
    showBreadcrumb: function (key, breadcrumb) {
      // Hide from TOC
      if (breadcrumb[key].hide_from_toc && breadcrumb[key].hide_from_page) {
        return false;
      }

      // Too small ignore.
      if (breadcrumb.length <= 2) {
        return true;
      }

      // Have we seen it flag?
      var seen = false;

      for (let i = 0; i < breadcrumb.length; i++) {
        if ((breadcrumb[i].type == "topic") || (breadcrumb[i].type == "content")) {
          seen = true;
        }
      }

      if (seen) {
        if (key >= (breadcrumb.length - 2)) {
          return false;
        } else {
          return true;
        }

      }

      return true;
    },

    // Get the back to home title.
    backToHomeTitle: function () {
      if (typeof this.activeLevel.name == "undefined") {
        return "Home";
      }

      if (this.activeLevel.name.length == 0) {
        return "Home";
      }

      return this.activeLevel.name;
    },

    // Take the user back come
    backToHome: function () {
      this.page = 'landing';

      // Set active categories.
      this.activeLevel = this.toc;

      // Update the TOC
      this.breadcrumb = [{ toc: this.toc, title: "Home" }];

      this.article = {};
    },

    // Toggle showing the TOC
    tocToggle: function () {
      if (this.showToc) {
        this.showToc = false;
      } else {
        this.showToc = true;
      }
    },

    contactGetHoneypot: function() {
      var that = this;
      axios.get('/widget/honeypot')
      .then(function (response) {
        that.honeypotHTML = response.data?.trim();
      })
      .catch(function (e) {
        console.log(e);
      });
    },

    // Contact form submit
    contactSubmit: function (submitEvent) {
      var that = this;

      // hide captcha error
      that.contactSubmitError = false;

      // Display the loading overlay
      this.showOverlay = true;

      // Build form to post back            
      var formData = new FormData();

      // Iteate over any file sent over appending the files to the form data.
      for (var i = 0; i < this.files.length; i++) {
        var file = this.files[i];
        formData.append('attachment[' + i + ']', file);
      }

      // Non-file form data.
      formData.append("expect", "200");
      formData.append("name", this.contact.name);
      formData.append("requester", this.contact.email);
      formData.append("details", this.contact.details);
      formData.append("loc", this.$route.query.__loc);
      formData.append("subject", this.contact.subject);
      formData.append("projectID", this.$route.query.__pc.split("-")[1]);
      if (this.config.multi_email) {
        formData.append("send_email", this.contact.send_email);
      }
      // get the honeypot fields and append them
      if(this.config.use_honeypot) {
        for (let element of submitEvent.target.elements) {
          if (element.name.indexOf(this.config.honeypot_field_prefix) !== -1) {
            formData.append(element.name, element.value);
          }
        }
      }

      // Function to send contact to backend server.
      var postFunc = function (token) {
        // Recaptcha
        if (token.length > 0) {
          formData.append("g-recaptcha-response", token);
        }

        // Send request to server.
        axios.post('/widget/contact-submit',
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(function (response) {
            that.files = [];
            that.showOverlay = false;
            that.contactSuccess = true;
          })
          .catch(function (e) {
            that.showOverlay = false;
            that.contactErrorMessage = "There was an error submitting your contact request.";
            that.contactSubmitError = true;
          });
      }


      // Do we have recaptcha? Then validate this request with recaptcha
      if (this.config.captcha_enabled && this.config.captcha_key && this.config.captcha_key.length) {
        try {
          grecaptcha.execute(this.config.captcha_key, { action: 'submit' }).then(function (token) {
            postFunc(token);
          });
        } catch (e) {
          that.contactErrorMessage = "reCAPTCHA error, could not submit request.";
          that.contactSubmitError = true;
          console.log("Widget reCAPTCHA " + e);
          this.showOverlay = false;
        }
      } else {
        postFunc("");
      }
    },

    // Handles a change on the file upload
    handleFilesUpload: function () {
      for (var i = 0; i < this.$refs.files.files.length; i++) {
        this.files.push(this.$refs.files.files[i]);
      }
    },

    // Remove file from the upload list.
    removeFile: function (file) {
      this.files.splice(this.files.indexOf(file), 1);
    },

    // This gets called when the iframe html is loaded
    articleIframelLoaded: function () {
      this.showArticleIFrame = true;
    },

    // View an article from recommended
    viewRecommendedArticle: function (row) {
      this.breadcrumb = [this.breadcrumb[0]];
      this.getToc();
      this.viewArticle(row);
    },

    // View an category from recommended
    viewRecommendedCategory: function (row) {
      this.breadcrumb = [this.breadcrumb[0]];
      this.article = {};
      this.matchCategory(this.toc.categories, row.id);
    },

    // Navigate to a category from clicking a link in an article
    gotoCategory: function (catID) {
      this.breadcrumb = [this.breadcrumb[0]];
      this.article = {};
      this.matchCategory(this.toc.categories, catID, true);
    },

    // Find a category by recursing the TOC
    matchCategory: function (row, id, firstLevel) {
      for (var i = 0; i < row.length; i++) {
        if (row[i].id == id) {
          this.changeTocLevel(row[i]);
          return;
        }

        // Go deeper
        if (row[i].categories && row[i].categories.length) {
          this.matchCategory(row[i].categories, id);
        }
      }
    },

    // View an article
    viewArticle: function (row, attempts = 0) {
      var that = this;

      // make sure the config is loaded, if it isn't attempt to wait for it before failing
      if(! this.config.root_path && attempts < 10) {
        setTimeout(function () { that.viewArticle(row, attempts + 1); }, 100);
      } else if(! this.config.root_path && attempts >= 10) {
        return false;
      } else {
        this.setBreadcrumb(row.id);
        this.page = 'article';
        this.searchTerm = "";
        this.showArticleIFrame = this.article.id && row.id == this.article.id;
        this.article = row;
        var url = this.fetchArticleUrl();
        if (row.search_id)
          url += '&__s=' + row.search_id;
        this.article.url = url;
        this.$forceUpdate();
        return false;
      }
    },

    // count url redirects in page views
    countRedirect: function (aid) {
      var that = this;
    
        // AJAX call count the url redirect in pageviews			
      axios.get('/widget/count-redirect?__pc=' + this.$route.query.__pc + '&id=' + aid)
          .then(function (response) {
          })
          .catch(function (e) {
            console.log(e);
          });
    },

    fetchArticleUrl: function () {
      var url = new URL('https://' + this.config.helpdomains[0] + this.config.root_path + '/fetch-article/hash/' + this.article.url_hash)
      url.searchParams.set('widget', 'true');
      url.searchParams.set('w2', 'true');

      if (this.token) {
        url.searchParams.set('st', this.token);
      }
      if (new URLSearchParams(window.location.search).get('coep') == 'credentialless') {
        url.searchParams.set('coep','credentialless')
      }
      return url.toString()
    },

    // Move further into the TOC.
    changeTocLevel: function (tocLevel, dontBreadcrumb) {
      var previousLevelId = this.activeLevel.id;
      this.page = 'landing';
      this.activeLevel = tocLevel;

      // Is this a topic / content category
      if ((this.activeLevel.type == "topic") || (this.activeLevel.type == "content")) {
        this.breadcrumb.push({ title: tocLevel.name, url_hash: tocLevel.url_hash, type: this.activeLevel.type, toc: [] });
        this.page = 'article';
        this.searchTerm = "";
        this.showArticleIFrame = previousLevelId == this.activeLevel.id;
        if (this.token) {
          this.article.url = 'https://' + this.config.helpdomains[0] + this.config.root_path + '/fetch-article/hash/' + this.activeLevel.url_hash + '?widget=true&w2=true&st=' + this.token;
        }
        else {
          this.article.url = 'https://' + this.config.helpdomains[0] + this.config.root_path + '/fetch-article/hash/' + this.activeLevel.url_hash + '?widget=true&w2=true';
        }
      }

      // Add to breadcrumb
      if (!dontBreadcrumb) {
        this.breadcrumb.push({ title: tocLevel.name, url_hash: tocLevel.url_hash, type: this.activeLevel.type, toc: tocLevel });
      }
    },

    // Back to list view. Used on article page.
    backToListView: function () {
      this.page = 'landing';
    },

    // List blog articles
    listBlogArticles: function (activeLevel) {
      return activeLevel.articles;
    },

    // Get PDF download url
    getPdfDownloadUrl: function () {
      return 'https://' + this.config.helpdomains[0] + this.article.pdf;
    },

    // Print screen
    printScreenUrl: function () {
      let s = window.location.href.split("/widget-app/");
      let url = s[0] + '/widget-app/print.php' + s[1].replace('#', '');
      return url + '&__id=' + this.article.id;
    },

    // Open non-article pages
    getViewPageUrl: function (activeLevel) {
      var path = "";

      for (let i = 0; i < this.breadcrumb.length; i++) {
        path = this.breadcrumb[i].url_hash;
      }

      if (!path) {
        path = "";
      }

      return 'https://' + this.config.helpdomains[0] + '/help/' + path;
    },

    // View on site url
    getViewOnSiteUrl: function () {
      return this.article.url.split("?")[0].replace("/fetch-article/hash/", "/");
    },

    // Scroll to top
    scrollToTop: function () {
      // Main iframe
      $(".widget__body").animate({ scrollTop: 0 }, "slow");

      // Second iframe
      var d = document.getElementById('article-iframe');

      if (d) {
        d.contentWindow.postMessage({ action: 'scroll-top' }, '*');
      }
    },

    // Filter HTML to make it widget happy
    getFilteredHtml: function () {
      return this.article.current_version.en.text.replace(/href/gi, 'target="_blank" href');
    },

    // Refresh the html portions that are affected by reader group permissions
    refreshViews: function () {
      /**
       * TODO: probably want to handle this differently based on whether the widget is open and
       * what the person is currently looking at. Maybe we want an overlay for when they aren't authed yet or lose auth?
       */
      this.getToc();
      if (!this.config.suggested_url || this.config.suggested_url != 'none') {
        this.getRecommended();
      }
    },

    // put the widget back into an "empty" state
    reset: function() {
      var that = this;

      that.backToHome();
      that.lastPage = '';
      that.searchResults = [];
      that.glossaryTerm = false;
      that.searchTerm = '';
      that.recommended = [],
      that.manualRecPage = false;
    },

    // Pass in a hash or id and then open that article
    openArticleFromHashOrId: function (search) {
      var that = this;
      
      // If we have a full URL remove the base.
      if (search.indexOf("://")) {
        var parts = search.split("/");
        search = parts[parts.length - 1];
      }

      // AJAX call to get data			
      axios.get('/widget/toc?tree=no-tree&__pc=' + this.$route.query.__pc)
        .then(function (response) {
          // Check if we get an auth error back
          if (response.data.error && response.data.error == 'Unauthorized')
            that.authErrorResponse();

          // Loop through and find the article. 
          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].id == search) {
              if (response.data[i].type == 'article') {
                that.viewArticle(response.data[i]);
              }

              if (response.data[i].type == 'category') {
                that.viewRecommendedCategory(response.data[i]);
              }
            }

            if (response.data[i].url_hash == search) {
              if (response.data[i].type == 'article') {
                that.viewArticle(response.data[i]);
              }

              if (response.data[i].type == 'category') {
                that.viewRecommendedCategory(response.data[i]);
              }
            }

            // Is this an old link?
            if (response.data[i].type == 'article') {
              var redirects = response.data[i].redirect_link;
              if (redirects?.includes(search)) {
                that.viewArticle(response.data[i]);
              }
            }
          }
        })
        .catch(function (e) {
          console.log(e);
        });
    },

    // Is this browser IOS based?
    isIOS: function () {
      return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    },

    // Fancy console log
    consoleLog: function (str) {
      console.log(JSON.parse(JSON.stringify(str)));
    },
    updateContact: function (contact) {
      this.contact.name = contact.name;
      this.contact.email = contact.email;
      this.contact.subject = contact.subject;
      this.contact.details = contact.details;
    },
    knowledgeTabNavigate: function () {
      if (this.page != 'article' && this.article.url) {
        this.showArticleIFrame = false;
        this.page = 'article';
      }
      else {
        this.page = 'landing';
        this.article = {};
      }
    },
    contactTabNavigate: function() {
      this.page = 'contact';
      if (this.config.use_honeypot) {
        this.contactGetHoneypot();
      }
    }
  },

  // Called at the start to load data
  created: function () {
    // Remove display:none; from #app div
    this.loaded = true;

    //this.getConfig();

    // Special case for printing
    if (this.$route.query.__id) {
      this.printMode = true;
      this.viewArticle(this.$route.query.__id);
      setTimeout(function () { window.print(); }, 1000);
    }

    // Setup listening for messages from the parent. 
    var app_eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var app_eventer = window[app_eventMethod];
    var app_messageEvent = app_eventMethod === "attachEvent" ? "onmessage" : "message";

    // Process messages from the parent 
    var that = this;
    app_eventer(app_messageEvent, function (e) {
      var action = e.data.action;
      var data = e.data.data;

      // Figure out what to do with the action.
      switch (action) {
        case 'open':
          that.open();
          break;

        case 'closed':
          that.closed();
          break;

        case 'update-config':
          that.updateConfig(data);
          break;

        case 'authenticate':
          that.authenticate(data);
          break;

        case 'refresh':
          that.refreshViews();
          break;

        case 'goto-category':
          that.gotoCategory(data);
          break;

        case 'open-contact':
          that.page = 'contact';
          that.contactGetHoneypot();
          break;

        case 'open-recommended':
          that.page = 'recommended';
          break;

        case 'update-recommended':
          that.getRecommended(data);
          break;

        case 'open-landing':
          that.page = 'landing';
          break;

        case 'open-article':
          that.openArticleFromHashOrId(data);
          break;

        case 'open-category':
          that.openArticleFromHashOrId(data);
          break;

        case 'parent-width':
          that.parentWidth = data;
          break;

        case 'reset':
          that.reset();
          break;

        case 'DOMContentLoaded':
          that.articleIframelLoaded();
          break;
        case 'update-contact':
          that.updateContact(data);
          break;
      }
    });

    // Send message to parent saying widet is loaded.
    // TODO: Change * to real domain. Or look into if there are security issues doing this.
    // We add a small delay to make sure out loading ajax calls are done.
    setTimeout(function () {
      parent.postMessage({ action: 'loaded' }, '*');
    }, 1000);
  },

  // Watch variables for change.
  watch: {
    'page': function (newVal, oldVal) {
      var data = { oldTab: oldVal, newTab: newVal };

      //reset submitted contact form after navigating away from it
      if (oldVal == 'contact' && this.contactSuccess) {
        this.contactSuccess = false;
      }

      // Internal event outside of vueJS
      if (typeof onTabChange == "function") {
        setTimeout(function () { onTabChange(data); }, 1);
      }

      // Send to parent.
      parent.postMessage({ action: 'tab-change', data: data }, '*');
    }
  }
});
